export default class Detail {
  /**
   * @param item A Product Object
   * @param editable A Edited item
   * @param qtyReal A Item Qty
   * @param includeDeliveryLetter A Item Delivery include letter
   */
  constructor (item, editable, qtyReal, includeDeliveryLetter) {
    this.item = item
    this.item_id = item.item_id
    this.editable = editable
    this.qty_real = qtyReal
    this.warranty = {
      id: item.warranty_id,
      warranty: item.warranty
    }
    this.price = 0
    this.price_edit = false
    if (item.price_edit) {
      this.price_edit = item.price_edit
      this.price = item.price
    }
    this.include_delivery_letter = includeDeliveryLetter
  }

  setPrice (customer, payMethod) {
    const priceEdited = this.price
    const priceList = extractPrice(this.item)
    const method = (payMethod && payMethod.type_id == 2) ? 2 : 1
    if (customer) {
      this.price = priceList[customer.type_id][method]
    } else {
      this.price = priceList[1][method]
    }
    const original_price = this.price
    if (this.price_edit) {
      this.price = priceEdited
      this.original_price = original_price
    }
  }
}

function extractPrice (item) {
  return item.price_list;
  // const retail = {
  //   cash: item.retail,
  //   credit: item.retail
  // }

  // const d1 = {
  //   cash: item.dealerone_cash,
  //   credit: item.dealerone_credit
  // }

  // const d2 = {
  //   cash: item.dealertwo_cash,
  //   credit: item.dealertwo_credit
  // }

  // return {
  //   1: retail,
  //   2: d1,
  //   3: d2
  // }
}

/** this method only execute from external */
export function setItemPrice (item, customer, payMethod) {
  const priceList = extractPrice(item)
  const method = (payMethod && payMethod.type_id == 2) ? 2 : 1
  if (customer) {
    item.price = priceList[customer.type_id][method]
  } else {
    item.price = priceList[1][method]
  }
  return item
}